<template>
  <div
    class="status-indicator"
    :style="alignStyle"
  >
    <span
      class="status-indicator__dot"
      :style="dotStyle"
    />

    <span
      class="status-indicator__label"
    >
      {{ label }}
    </span>
  </div>
</template>

<script>
const DEFAULT_DOT_BORDER_COLOR = '#9CA3AF'
const ALIGN_TO_JUSTIFY = {
  left: 'flex-start',
  center: 'center',
  right: 'flex-end'
}
const DEFAULT_ALIGN = 'left'

export default {
  name: 'StatusIndicator',

  props: {
    label: {
      type: String,
      default: '-'
    },
    // Fills the dot - the same colour the old pill used as its background.
    color: {
      type: String,
      default: null
    },
    // Outlines the dot - the old pill's text/border colour.
    borderColor: {
      type: String,
      default: null
    },
    align: {
      type: String,
      default: DEFAULT_ALIGN
    }
  },

  computed: {
    dotStyle () {
      return {
        backgroundColor: this.color || 'transparent',
        borderColor: this.borderColor || DEFAULT_DOT_BORDER_COLOR
      }
    },

    alignStyle () {
      return {
        justifyContent: ALIGN_TO_JUSTIFY[this.align] || ALIGN_TO_JUSTIFY[DEFAULT_ALIGN]
      }
    }
  }
}
</script>

<style scoped>
.status-indicator {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.status-indicator__dot {
  flex: 0 0 auto;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 1px solid;
  box-sizing: border-box;
}

.status-indicator__label {
  font-family: 'Satoshi', sans-serif;
  font-size: 14px;
  color: #374151;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
